import ShowMessageContainer from './containers/ShowMessageContainer'

export default ShowMessageContainer
